<template>
  <span>
    <button :id="id" class="btn btn-danger" style="width: 2.5rem;" @click="confirmDelete"><i class="fa fa-times"></i></button>
    <form :action="route" method="POST">
      <input type="hidden" name="_token" :value="csrf" />
      <input type="hidden" name="_method" value="DELETE" />
      <button ref="submit" style="display:none;">Submit</button>
    </form>
    <confirmation-modal ref="deleteModal"></confirmation-modal>
  </span>
</template>

<script>
export default {
  props: ['type', 'id'],
  data() {
    return {
      form: {
        name: null,
        options: null,
      },
      route: this.type == 'user' ? 'users/' + this.id : 'roles/' + this.id,
      csrf: document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content"),
    };
  },
  methods: {
    confirmDelete() {
      let message = 'Are you sure you want to delete this ' + this.type + ' ?';

      this.$refs.deleteModal
        .open(message, "Confirm", "yesNo", false)
        .then((proceed) => {
          if (proceed) {
            this.$refs.submit.click();
          }
        });
    },
  },
};
</script>
